import { useQuery } from "@tanstack/react-query";
import { getRevenueMonthly } from "../service/revenue.service";
import type { RevenueItem, RevenueParams } from "@/types/revenue.type";

export const useRevenue = (params: RevenueParams) => {
    return useQuery<RevenueItem[]>({
        queryKey: ["revenue-monthly", params.email],
        queryFn: () => getRevenueMonthly(params),
        enabled: !!params.email,
    });
};